// extracted by mini-css-extract-plugin
export var grid = "_m-0";
export var span1 = "_m-2";
export var span10 = "_m-b";
export var span10L = "_m-z";
export var span10M = "_m-n";
export var span10Xl = "_m-1b";
export var span11 = "_m-c";
export var span11L = "_m-10";
export var span11M = "_m-o";
export var span11Xl = "_m-1c";
export var span12 = "_m-d";
export var span12L = "_m-11";
export var span12M = "_m-p";
export var span12Xl = "_m-1d";
export var span1L = "_m-q";
export var span1M = "_m-e";
export var span1Xl = "_m-12";
export var span2 = "_m-3";
export var span2L = "_m-r";
export var span2M = "_m-f";
export var span2Xl = "_m-13";
export var span3 = "_m-4";
export var span3L = "_m-s";
export var span3M = "_m-g";
export var span3Xl = "_m-14";
export var span4 = "_m-5";
export var span4L = "_m-t";
export var span4M = "_m-h";
export var span4Xl = "_m-15";
export var span5 = "_m-6";
export var span5L = "_m-u";
export var span5M = "_m-i";
export var span5Xl = "_m-16";
export var span6 = "_m-7";
export var span6L = "_m-v";
export var span6M = "_m-j";
export var span6Xl = "_m-17";
export var span7 = "_m-8";
export var span7L = "_m-w";
export var span7M = "_m-k";
export var span7Xl = "_m-18";
export var span8 = "_m-9";
export var span8L = "_m-x";
export var span8M = "_m-l";
export var span8Xl = "_m-19";
export var span9 = "_m-a";
export var span9L = "_m-y";
export var span9M = "_m-m";
export var span9Xl = "_m-1a";
export var stretch = "_m-1";